module.exports = __webpack_public_path__ + "media/images/front/common/navClose-f4dca38a93887fe84be9c139f4d4958a.svg";